import { InjectionToken } from '@angular/core';
import { UserSettingsDataConfig } from '@prlw/data/user-settings/user-settings-data.module';

export const USER_SETTINGS_DATA_CONFIG =
  new InjectionToken<UserSettingsDataConfig>('user-settings-data-config');
